export function planTypeListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePlanTypeId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreatePlanTypeId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function planTypeMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyPlanTypes(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      planTypeId: resource.objectId,
    })),
  };
}